import { render, staticRenderFns } from "./ContentTemplateEditor.vue?vue&type=template&id=2f67f890&"
import script from "./ContentTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./ContentTemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./ContentTemplateEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports